export default __webpack_public_path__ + "images/EE.b35b66c.png";